module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "banner"
  }, [_c('section', {
    attrs: {
      "id": "banner"
    }
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('p', [_vm._v("Découvrez toutes les fonctionnalités")]), _vm._v(" "), _c('h1', [_vm._v("PLAYER DEMO")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-53ea07ab!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Banner.vue
// module id = 161
// module chunks = 1